// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraNumeric } from './TerceraNumeric';
export class QuickTableNumeric extends TerceraNumeric {
    constructor(initProps, data, callback, rect) {
        super();
        const editingInfo = data.cell.QuickTableEditingInfo;
        void this.set({
            minValue: editingInfo.Min,
            maxValue: editingInfo.Max,
            step: editingInfo.Inc,
            decimalPrecision: editingInfo.DecimalPlaces
        });
        this.tag = data;
        this.callBack = callback;
        void this.set('value', data.cell.value);
        this.setBounds(rect.X, rect.Y, rect.Width, rect.Height);
        void this.set('isPosAbsolute', true);
    }
    oncomplete() {
        super.oncomplete();
        this.setFocus();
    }
    processEnterKeyDown() {
        this.lostFocus();
    }
    lostFocus() {
        super.lostFocus();
        this.callBack(this.get('value'), this.tag);
    }
}
TerceraNumeric.extendWith(QuickTableNumeric, {
    data: function () {
        return {
            additionalClass: 'table-numeric'
        };
    }
});
